export default __webpack_public_path__ + "locales/en-US/translation.json";